import React, { useContext, useEffect } from 'react'

import { WappContext, withWapp } from 'wapplr-react/dist/common/Wapp'
import getUtils from 'wapplr-react/dist/common/Wapp/getUtils'

import AppContext from '../../App/context'
import Form from '../../Form'

import style from './style.css'
import AccountContext from '../context'

function ResetPassword(props) {

    const {
        SubmitProps = {}
    } = props

    const accountContext = useContext(AccountContext)
    const { user, name } = accountContext

    const appContext = useContext(AppContext)
    const context = useContext(WappContext)
    const utils = getUtils(context)

    const { wapp, req } = context

    async function onSubmit(e, formData) {
        return await utils.sendRequest({
            requestName: name + 'ResetPassword',
            args: formData,
            redirect: { pathname: appContext.routes.userRoute + '/:_id', search: '', hash: '' }
        })
    }

    let formDataFromResolvers = {}
    try {
        formDataFromResolvers = utils.getGlobalState('res.graphql.mutation.' + name + 'ResetPassword.formData')
    } catch (e) {
    }

    const formData = {
        ...formDataFromResolvers,
        submit: {
            label: appContext.labels.resetPasswordSubmitLabel,
            fullWidth: true,
            ...SubmitProps
        }
    }

    const query = req.wappRequest.query

    if (query.hash) {
        formData.passwordRecoveryKey.value = query.hash
        formData.passwordRecoveryKey.disabled = true
    }

    if (query.email) {
        formData.email.value = query.email
        formData.email.disabled = true
    }

    if (user?._id && user?.email) {
        formData.email.value = user.email
        formData.email.disabled = true
    }

    useEffect(() => {
        if (user?._id && query.email && query.email !== user.email) {
            async function asyncFunction() {
                await new Promise((resolve) => setTimeout(resolve, 1))
                await appContext.template.current?.actions?.setSnackMessage(appContext.messages.thisIsNotYourResetPasswordKey, 6000, 'error')
            }

            // noinspection JSIgnoredPromiseFromCall
            asyncFunction()
        }
    }, [])

    formData['record.col1'] = {
        isContainer: true,
        hiddenContainer: true
    }

    wapp.styles.use(style)

    return (
        <Form
            formData={formData}
            onSubmit={onSubmit}
            successMessage={
                appContext.messages.resetPasswordSuccessMessage
            }
        />
    )

}

export default withWapp(ResetPassword)
